import queryString from 'query-string';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Loader,
} from 'semantic-ui-react';

import client from '../../../core/services/client';

import {
  Container,
  Typography,
} from './styles';

class Unsubscribe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      message: 'You have successfully unsubscribed from email communications.',
    };
  }

  componentDidMount() {
    const { email } = queryString.parse(this.props.location.search);

    if (!email) {
      this.setState({
        message: 'Invalid email address to unsubscribe.',
        isLoading: false,
      });

      return;
    }

    client.post('/unsubscribe', { email })
      .then(() => this.setState({ isLoading: false }))
      .catch(() => this.setState({
        message: 'Error while unsubscribing, please try again later.',
        isLoading: false,
      }));
  }

  render() {
    if (this.state.isLoading) {
      return (
        <Container>
          <Loader active inline data-loader="unsubscribe-loader">
            Unsubscribing...
          </Loader>
        </Container>
      );
    }

    return (
      <Container>
        <Typography>{this.state.message}</Typography>
      </Container>
    );
  }
}

Unsubscribe.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.shape({
      email: PropTypes.string,
    }),
  }).isRequired,
};

export default Unsubscribe;
